import { Component, inject, Injector, input, OnInit, signal } from '@angular/core';
import { TourismEventsComponent } from '../tourism-events.common';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CategoryEvent, EventStatus } from '../tourism-events.model';
import { effect } from '@angular/core';
import { Permissions } from '@/common/enums/Permissions';
import { ExchangeRateService } from '@/event-business/exchange-rate.service';
import { CURRENCY_EUR } from '@/common/constants/currencies';

@Component({
	selector: 'app-tourism-events-full',
	templateUrl: './tourism-events-full.component.html',
	styleUrls: ['./tourism-events-full.component.css'],
})
export class TourismEventsFullComponent extends TourismEventsComponent implements OnInit {
	errors = {
		name: '',
		vehicles: [],
		owner: '',
		date_from: '',
		date_to: '',
		category: '',
	};

	editor = ClassicEditor;
	editorConfig = {
		toolbar: ['bold', 'italic', '|', 'bulletedList', 'numberedList'],
	};

	category = input<CategoryEvent>(null);

	readonly Permissions = Permissions;
	readonly CURRENCY_EUR = CURRENCY_EUR;

	agreementValueRateDate: string | null = null;
	predictedProfitRateDate: string | null = null;

	private readonly injector = inject(Injector);
	private readonly exchangeRateService = inject(ExchangeRateService);

	initializeCategorySet(): void {
		effect(() => (this.event.category = this.selectedCategory()), { injector: this.injector });
	}

	ngOnInit(): void {
		super.ngOnInit();
		if (!!this.category()) {
			this.selectedCategory.set(this.category());
		}
		this.initializeCategorySet();
	}

	categoryChanged(): void {
		switch (this.event.category) {
			case 'OSKAR':
				if (!this.event.tourist_guides_program) {
					this.event.tourist_guides_program = ['virt'];
				}
				break;
		}
	}

	protected defaultValues(): void {
		this.event.status = EventStatus.PRELIMINARY;
		this.event.type = EventStatus.EVENT;
	}

	onAgreementValueCurrencyChange(): void {
		this.recalculateAgreementValuePln();
	}

	onAgreementValueChange(): void {
		this.recalculateAgreementValuePln();
	}

	onPredictedProfitCurrencyChange(): void {
		this.recalculatePredictedProfitPln();
	}

	onPredictedProfitChange(): void {
		this.recalculatePredictedProfitPln();
	}

	private recalculateAgreementValuePln(): void {
		if (this.event.agreement_value_currency !== CURRENCY_EUR || !this.event.agreement_value) {
			this.event.agreement_value_pln = null;
			this.agreementValueRateDate = null;
			return;
		}
		this.exchangeRateService.getExchangeRateDetails({ value: this.event.agreement_value }).then((result) => {
			this.event.agreement_value_pln = result.value;
			this.agreementValueRateDate = result.date;
		});
	}

	private recalculatePredictedProfitPln(): void {
		if (this.event.predicted_profit_currency !== CURRENCY_EUR || !this.event.predicted_profit) {
			this.event.predicted_profit_pln = null;
			this.predictedProfitRateDate = null;
			return;
		}
		this.exchangeRateService.getExchangeRateDetails({ value: this.event.predicted_profit }).then((result) => {
			this.event.predicted_profit_pln = result.value;
			this.predictedProfitRateDate = result.date;
		});
	}
}
